module.exports = __webpack_public_path__ + "img/c2.c5acd066.png";